export default __webpack_public_path__ + "static/media/lockIcon.fdcf0a27.svg";